import { RootState } from '@Store/index';
import {
  getLeaveStatusesDictSelector,
  getLeaveTypeDictSelector,
} from '@Store/selectors/dictionarySelector';
import { prepareRequisitionInfo } from '@Utils/requisitionInfo';
import { createSelector } from '@reduxjs/toolkit';

const leaveRequest = (state: RootState) => state.featureStores.leaveRequest;

export const currentLeaveRequest = createSelector(
  leaveRequest,
  ({ leaveRequest }) => leaveRequest
);

export const leaveRequestCreateRequisitionInfo = createSelector(
  [currentLeaveRequest, getLeaveStatusesDictSelector],
  (leaveRequest, leaveStatuses) => {
    const requisitionInfo = prepareRequisitionInfo(leaveRequest, leaveStatuses);
    return requisitionInfo;
  }
);

export const getLeaveTypeLabels = createSelector(
  getLeaveTypeDictSelector,
  (leaveTypes) => leaveTypes.map((leaveType) => leaveType.codeDesc)
);

export const getLeaveStatusLabels = createSelector(
  getLeaveStatusesDictSelector,
  (statuses) => statuses.map((status) => status.codeDesc)
);

export const getValidationSettings = createSelector(
  leaveRequest,
  ({ validationSettings }) => validationSettings
);
